import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-external-link-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M11 1H15V5M15 1L9 7M7 3H3C1.89543 3 1 3.89543 1 5V13C1 14.1046 1.89543 15 3 15H11C12.1046 15 13 14.1046 13 13V9"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none" />
    </svg>
  `,
})
export class ExternalLinkIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 16 16');
}
